module.exports = __webpack_public_path__ + "img/image_refundBuFen.7b855d9c.png";